import { LoaderFunction } from "react-router-dom";
import usePromiseFetcher from "../../../../common/core-ui/usePromiseFetcher.ts";
import {
  UpdateProgramDecision,
  ProgramDecision,
  updateProgramDecision,
} from "../../../../common/api/decimal/methods/course.ts";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";

export const updateProgramChoiceAction: LoaderFunction = async ({
  request,
}): Promise<unknown> => {
  const formData = await request.formData();
  const catalogId = formData.get("catalogId") as string;
  const programDecision = formData.get("programDecision") as ProgramDecision;
  if (catalogId && programDecision) {
    return updateProgramDecision(catalogId, programDecision);
  }
  return null;
};

export function useUpdateProgramChoiceFetcher() {
  return usePromiseFetcher<DecimalResult<UpdateProgramDecision>>();
}
